import { render, staticRenderFns } from "./TSkeletonLoader.vue?vue&type=template&id=7f2bdbf8&scoped=true&"
import script from "./TSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./TSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./TSkeletonLoader.vue?vue&type=style&index=0&id=7f2bdbf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2bdbf8",
  null
  
)

export default component.exports